import { useEffect } from 'react';

import _ from 'lodash';
import { connect } from 'react-redux';
import { getValues } from 'redux-form';

import ErrorOverlay from './ErrorOverlay';
import Intercom from '../components/Intercom';
import ThreatMetrix from '../components/ThreatMatrix/ThreatMetrix';
import { buildApplicationState } from '../helpers/applicationManager';
import {
    addPointerCursorToBody,
    mobileIsAnAppleDevice
} from '../helpers/helpers';
import {
    isIntroducer,
    getRequestedProductType
} from '../lendingAPI/lendingAPISelector';

const mapStateToProps = (state) => ({
    ui: state.ui,
    fetched: state.fetched,
    formValues: getValues(state.form.sign_up),
    intercomAppId: _.get(state, 'lendingAPI.context.data.intercom_app_id'),
    requestedProductType: getRequestedProductType(state),
    isIntroducerCustomer: isIntroducer(state),
    hasContextLoaded: _.has(state, 'lendingAPI.context.data.state_key')
});

const mapDispatchToProps = (dispatch) => ({
    retry: (action) => dispatch(action)
});

const SignupContainer = ({
    children,
    ui,
    fetched,
    formValues,
    retry,
    fetched: { intercomAttributes },
    intercomAppId,
    isIntroducerCustomer,
    hasContextLoaded
}) => {
    useEffect(() => {
        applyIOSMobileTooltipStyleHack();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const applyIOSMobileTooltipStyleHack = () => {
        if (mobileIsAnAppleDevice()) {
            addPointerCursorToBody();
        }
    };

    return (
        <>
            {children}
            {/* TODO: Separate the error overlay to make an error boundary component. */}
            {fetched.application.error && (
                <ErrorOverlay
                    show={true}
                    retry={retry}
                    action={fetched.application.error.action}
                    time={fetched.application.error.time}
                    latestAppState={buildApplicationState(
                        fetched.application.payload,
                        formValues
                    )}
                    latestUiState={ui}
                />
            )}
            {(import.meta.env.NODE_ENV !== 'test' &&
                _.isUndefined(intercomAttributes.display_widget)) ||
            intercomAttributes.display_widget ? (
                <Intercom
                    appID={intercomAppId}
                    email={intercomAttributes.email}
                    user_hash={intercomAttributes.email_hashed}
                />
            ) : null}
            {hasContextLoaded && !isIntroducerCustomer && <ThreatMetrix />}
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(SignupContainer);
